// extracted by mini-css-extract-plugin
export default {"dialog":"DialogNotifyWindow_dialog__oB201","dialogContent":"DialogNotifyWindow_dialogContent__a4ipd","dialogButton":"DialogNotifyWindow_dialogButton__kv--f"};